import { Table as AntTable } from 'antd';
import styled from 'styled-components';
import { TableProps } from './types';

export const TableWrapper = styled.div`
    position: relative;
    .ant-table-container {
        border: 1px solid #f0f0f0;
        border-radius: 8px;
    }
`;

export const StyledHeaderBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-block: 1rem;
    @media (max-width: 450px) {
        flex-direction: column;
        gap: 12px;
    }
`;

export const CountBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: ${(props) => props.theme.colors.primary.main.filled};
    border: 1px solid ${(props) => props.theme.colors.info.main.border};
    border-radius: 9999px;
    padding: 1px 4px;
    line-height: 1.2;
`;

export const StyledTable = styled(AntTable)<TableProps>`
    &.ant-table-wrapper {
        border-radius: 12px;
    }

    &.ant-table-wrapper .ant-table {
        border-radius: 8px;
    }

    &.ant-table-wrapper table {
        // border-collapse: unset;
    }
    &.ant-table-wrapper .ant-table-thead > tr > th {
        background: unset;
    }

    .ant-table-column-sorters {
        border-left: none !important;
        border-right: none !important;
    }

    .ant-table-column:hover .ant-table-column-sorters {
        border-left-color: transparent !important;
        border-right-color: transparent !important;
    }

    .ant-table-cell::before {
        content: unset !important;
    }

    .ant-table-container table tr th,
    .ant-table-container table tr td {
        border-right: none !important;
    }

    .ant-table-column-sorters {
        display: inline-flex;
        align-items: center;
        flex-direction: row-reverse;
    }

    .ant-table-column-sorters .ant-table-column-title {
        margin-left: 8px;
        margin-right: 0;
    }
`;
